import type { ReduxState } from '@/redux/app/state';

export const demoUsersFetchStatusSelector = (state: ReduxState) =>
  state.analytics.demoUsersFetchStatus;

export const demoUsersSelector = (state: ReduxState) =>
  state.analytics.demoUsers;